const shadows = {
  normal: '0px 8px 40px rgba(0, 0, 0, 0.3)',
}
export default shadows
